import React, { useEffect } from "react";
import privateAxios from "./utils/axiosPrivate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import "./assets/scss/admin.scss";
import useIdleTimeout from "./hooks/useIdleTimeout";
import { CustomRoute } from "./route/CustomRoute";
import { refreshTokenURL } from "./utils/constants/apiEndPoints";
import { useSelector } from "react-redux";

const App = () => {
  useIdleTimeout();
  const authUser = useSelector((state) => state.auth.authUser);

  useEffect(() => {
    let interval;
    if (authUser) {
      interval = setInterval(
        async () => {
          try {
            await privateAxios.post(refreshTokenURL);
          } catch {
            localStorage.clear();
            window.location.href = "/login";
          }
        },
        10 * 60 * 1000
      ); // every 10 minutes
    }

    return () => clearInterval(interval);
  }, [authUser]);

  return <CustomRoute />;
};

export default React.memo(App);
